
(function ($, Drupal) {
  'use strict';

  // This is used so mobile can have a drop down filter
  Drupal.behaviors.FilterAllStories = {

    initialized: false,

    attach: function (context) {
      if(!this.initialized){
        this.initialized = true;
        this.init(context);
      }
    },

    init: function(context) {

      // Cant use a varible for filters as they get removed and reappened when filter gets selected.
      var viewForm = function() { return document.querySelector(".view-all-stories .view-filters form");};
      var viewFormButton = function() { return document.querySelector(".js-mobile-toggle");};
      viewForm().classList.add("filter-hidden");

      document.addEventListener('click', function(e) {

        if (e.target.matches('.js-mobile-toggle')) {

          viewForm().classList.toggle("filter-hidden");
          
          if (viewForm().classList.contains("filter-hidden")) {
            viewFormButton().setAttribute('aria-expanded', false);
          }
          else {
            viewFormButton().setAttribute('aria-expanded', true);
          }
        }
      });

    }
  };

 
}(jQuery, Drupal));